// NOTE: Please check with #eng-all before adding anything here! Do not add any private keys or information!
export const whitelistedEnvVars = {
  adminUrl: process.env.ADMIN_URL,
  adminSegmentWriteKey: process.env.ADMIN_SEGMENT_WRITE_KEY,
  amplitudeApiKey: process.env.AMPLITUDE_API_KEY,
  apiUrl: process.env.API_URL,
  appEnv: process.env.APP_ENV,
  consumerUrl: process.env.CONSUMER_URL,
  dutchiePlusPlaygroundKey: process.env.DUTCHIE_PLUS_PLAYGROUND_KEY,
  dutchiePlusPlaygroundUrl: process.env.DUTCHIE_PLUS_PLAYGROUND_URL,
  ghostClientKey: process.env.GHOST_CLIENT_KEY,
  ghostApiUrl: process.env.GHOST_API_URL,
  googleAnalyticsID: 'UA-101536475-1',
  gtmContainerKey: process.env.GTM_CONTAINER_KEY,
  herokuSlugCommit: process.env.HEROKU_SLUG_COMMIT,
  launchDarklyClientId: process.env.LAUNCH_DARKLY_CLIENT_ID,
  logrocketIdAdmin: process.env.LOGROCKET_ID_ADMIN,
  logrocketIdCheckout: process.env.LOGROCKET_ID_CHECKOUT,
  logrocketIdMarketplace: process.env.LOGROCKET_ID_MARKETPLACE,
  paysafeEnvironment: process.env.PAYSAFE_ENVIRONMENT,
  plaidEnv: process.env.PLAID_ENV,
  plaidKey: process.env.PLAID_KEY,
  pusherKey: process.env.PUSHER_KEY,
  sardineClientKey: process.env.SARDINE_CLIENT_KEY,
  segmentAnalyticsKey: process.env.SEGMENT_ANALYTICS_KEY,
  siftBeaconKey: process.env.SIFT_BEACON_KEY,
  streamKey: process.env.STREAM_MESSAGING_KEY_ID,
  stripeKey: process.env.STRIPE_PKEY,
};
